// src/models/landing-page.js
import memberservice from '@/services/memberservice';

// The LandingPage class returns a clean
// LandingPage object with only the data we need.
export class Member {
  constructor({
    id = null,
    club = '',
    email = '',
    firstname = '', 
    lastname = '',
    telephone = '',
    birthday = '',
    memberType = '',
    status = '',
    leaveDate = null,
  } = {}) {
    this.id = id
    this.club = club
    this.email = email
    this.firstname = firstname
    this.lastname = lastname
    this.telephone = telephone
    this.birthday = birthday
    this.memberType = memberType
    this.status = status
    // Set by the memberservice when the member or its group is disabled; read-only.
    this.leaveDate = leaveDate
  }
}

// We use an adapter to bring the API response
// from the Contentful API into the correct format
// for our LandingPage class.
//export function responseAdapter({ fields, sys }) {
//  return new Event({ ...fields, ...sys });
//}

export function responseAdapter(response) {

  let out = [];
  if(response == null){
    return out; 
  }
  else if (Array.isArray(response.data)) {
    response.data.forEach(element => {
      mapAndAdd(out, element)
    });
  } else if(response.data != null){
    mapAndAdd(out, response.data);
    return out[0];
  }else if(response != null){
    mapAndAdd(out, response);
    return out[0];
  }
  return out;
}

function mapAndAdd(out, element){
  out.push(new Member({ ...element }));
}

// We wrap the Contentful API client to format
// the response exactly the way we like it.
export default {
  async getConfig() {
    return await memberservice.getConfig();
  },
  async getCount() {
    return await memberservice.getCount();
  },
  async getAll() {
    return responseAdapter(await memberservice.getAll());
  },
  async update(memberId, member) {
    return responseAdapter(await memberservice.update(memberId, member));
  },
  async delete(memberId) {
    return await memberservice.deleteMember(memberId);
  },
  async getByFirstAndLastname(firstname, lastname) {
    return responseAdapter(await memberservice.getByFirstAndLastname(firstname, lastname));
  },
  async isMember(firstname, lastname) {
    const response = await memberservice.getByFirstAndLastname(firstname, lastname);
    const status = response?.status;

    if (status == null) {
      return false;
    }

    return status >= 200 && status < 300;
  },
};
